import axios from "axios";
import { environment } from "../../../environments/environment";

export const getOrdersReceiveList = (page, pageSize, search, order, body) => {
  let params = new URLSearchParams();
  params.append("page", page);
  params.append("pageSize", pageSize);
  params.append("search", search);
  params.append("orderBy", order);

  return axios.post(environment.getOrdersReceivingList + params, body);
};

export const receiveOrder = (body) => {
  return axios.post(environment.receiveOrder, body);
};

export const getNLAHierarchySvc = (partId) => {
  let params = new URLSearchParams();
  params.append("partId", partId);

  return axios.get(environment.getNLAHierarchy + params);
};

export const getActualsSvc = (serializedPartId) => {
  let params = new URLSearchParams();
  params.append("serialiazedPartId", serializedPartId);

  return axios.get(environment.getActuals + params);
};

export const getReceivingET = (partId) => {
  let params = new URLSearchParams();
  params.append("partId", partId);

  return axios.get(environment.getReceivingET + params);
};

export const saveInitialPartActualsSvc = (body) => {
  return axios.post(environment.savePartInitialActuals, body);
};

export const saveSerializedPartSvc = (body)=>{
  return axios.post(environment.saveSerializedPartInReceiving , body)
}